import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import Button from "../../../components/Button";
import ProgrammeFormFields from "../../programmes/ProgrammeFormFields";
import { useProgrammeDetail } from "../../../../hooks/useProgrammeDetail";
import { useUpdateProgramme } from "../../../../hooks/useUpdateProgramme";
import type { ProgrammeDto } from "../../../../api/programmesApi";

export default function ProgrammeEditInParcours() {
  const { id = "", programmeId = "" } = useParams<{ id: string; programmeId: string }>();
  const navigate = useNavigate();
  const detail = useProgrammeDetail(programmeId);
  const update = useUpdateProgramme(programmeId);
  const [draft, setDraft] = useState<ProgrammeDto | null>(null);

  useEffect(() => {
    if (detail.data) {
      setDraft({
        title: detail.data.title,
        subtitle: detail.data.subtitle,
        date: detail.data.date,
        endDate: detail.data.endDate,
        time: detail.data.time,
        endTime: detail.data.endTime,
        addressName: detail.data.addressName,
        lieuId: detail.data.lieu?.id,
        imageLink: detail.data.imageLink,
        price: detail.data.price,
        tag: detail.data.tag,
        parcoursId: detail.data.parcoursId ?? id,
      });
    }
  }, [detail.data, id]);

  if (detail.isLoading || !draft) return <div className="bo-loading">Chargement…</div>;

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    update.mutate(draft);
  };

  return (
    <form onSubmit={onSubmit}>
      <PageHeader
        title={`Éditer · ${detail.data?.title}`}
        actions={
          <>
            <Button type="button" variant="ghost" onClick={() => navigate(`/admin/parcours/${id}/programmes`)}>
              Retour
            </Button>
            <Button type="submit" variant="primary" loading={update.isPending}>
              Enregistrer
            </Button>
          </>
        }
      />
      <div className="bo-card">
        <ProgrammeFormFields value={draft} onChange={setDraft} />
      </div>
      {update.isSuccess && <p className="bo-success-text">Programme mis à jour.</p>}
    </form>
  );
}
